

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

const drawerWidth = 260;

const drawerMiniWidth = 80;

const transition = {
  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
};

const containerFluid = {
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  "&:before,&:after": {
    display: "table",
    content: '" "'
  },
  "&:after": {
    clear: "both"
  }
};

const container = {
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  "@media (min-width: 768px)": {
    width: "750px"
  },
  "@media (min-width: 992px)": {
    width: "970px"
  },
  "@media (min-width: 1200px)": {
    width: "1170px"
  },
  "&:before,&:after": {
    display: "table",
    content: '" "'
  },
  "&:after": {
    clear: "both"
  }
};

const boxShadow = {
  boxShadow:
    "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
};

const card = {
  display: "inline-block",
  position: "relative",
  width: "100%",
  margin: "25px 0",
  boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
  borderRadius: "6px",
  color: "rgba(0, 0, 0, 0.87)",
  background: "#fff"
};

const defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: "300",
  lineHeight: "1.5em"
};

const primaryColor = "#7168ef";
const warningColor = "#ff9800";
const dangerColor = "#f44336";
const successColor = "#9EF206";
const infoColor = "#7168ef";
const secondblueColor = "#2226C8";
const actionColor = "#7168ef"
const grayColor = "#999999";
const covidBlueColor = "#38BCD7"

const primaryBoxShadow = {
  boxShadow: "none"
};
const infoBoxShadow = {
  boxShadow: "none"
};
const successBoxShadow = {
  boxShadow: "none"
};
const warningBoxShadow = {
  boxShadow: "none"
};
const dangerBoxShadow = {
  boxShadow: "none"
};
const secondblueBoxShadow = {
  boxShadow: "none"
};

// old card headers
const orangeCardHeader = {
  background: "#fb8c00",
  ...warningBoxShadow
};
const greenCardHeader = {
  background: "#43a047",
  ...successBoxShadow
};
const redCardHeader = {
  background: "#e53935",
  ...dangerBoxShadow
};
const blueCardHeader = {
  background: "#00acc1",
  ...infoBoxShadow
};
const purpleCardHeader = {
  background: "#8e24aa",
  ...primaryBoxShadow
};
const whiteCardHeader = {
  backgroundColor: "#FFFFFF",
  border: "solid"
};
// new card headers
const warningCardHeader = {
  background: "rgb(251, 140, 0)",
  ...warningBoxShadow
};
const successCardHeader = {
  background: "#8DDB00",
  ...successBoxShadow
};
const dangerCardHeader = {
  background: "#e53935",
  ...dangerBoxShadow
};

const infoCardHeader = {
  padding: '0',
  margin: '0',
  background: '#fff',
  boxShadow: 'none',
  color: '#333',
  '& h1, h2, h3, h4, h5, h6': {
    fontWeight: '900',
    margin: '20px 15px',
    fontSize: '1.5rem'
  }
};

const primaryCardHeader = {
  padding: '0',
  margin: '0',
  background: '#fff',
  boxShadow: 'none',
  color: '#333',
  '& h1, h2, h3, h4, h5, h6': {
    fontWeight: '900',
    margin: '20px 15px',
    fontSize: '1.5rem'
  }
};
const secondblueCardHeader = {
  background: "#2226C8",
  ...secondblueBoxShadow
};

const cardActions = {
  margin: "0 20px 10px",
  paddingTop: "10px",
  borderTop: "1px solid #eeeeee",
  height: "auto",
  ...defaultFont
};

const cardHeader = {
  margin: "-20px 15px 0",
  borderRadius: "3px",
  padding: "15px"
};

const defaultBoxShadow = {
  border: "0",
  borderRadius: "3px",
  boxShadow:
    "0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  padding: "10px 0",
  transition: "all 150ms ease 0s"
};

const tooltip = {
  padding: "10px 15px",
  minWidth: "130px",
  color: "#FFFFFF",
  lineHeight: "1.7em",
  background: "rgba(85,85,85,0.9)",
  border: "none",
  borderRadius: "3px",
  opacity: "1!important",
  boxShadow:
    "0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
  maxWidth: "200px",
  textAlign: "center",
  fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  textShadow: "none",
  textTransform: "none",
  letterSpacing: "normal",
  wordBreak: "normal",
  wordSpacing: "normal",
  wordWrap: "normal",
  whiteSpace: "normal",
  lineBreak: "auto"
};

const title = {
  color: "#3C4858",
  textDecoration: "none",
  fontWeight: "300",
  marginTop: "30px",
  marginBottom: "25px",
  minHeight: "32px",
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  "& small": {
    color: "#777",
    fontSize: "65%",
    fontWeight: "400",
    lineHeight: "1"
  }
};

const cardTitle = {
  ...title,
  marginTop: "0",
  marginBottom: "3px",
  minHeight: "auto",
  "& a": {
    ...title,
    marginTop: ".625rem",
    marginBottom: "0.75rem",
    minHeight: "auto"
  }
};

const cardSubtitle = {
  marginTop: "-.375rem"
};

const cardLink = {
  "& + $cardLink": {
    marginLeft: "1.25rem"
  }
};

const actionButton = {
  textTransform: 'capitalize',
  background: `${actionColor} !important`,
  height: '35px',
  minWidth: '120px'
};

const dangerActionButton = {
  ...actionButton,
  background: `${dangerColor} !important`,
};

const actionIconButton = {
  textTransform: 'capitalize',
  background: `${actionColor} !important`,
  height: '30px',
  width: '30px'
};

const dangerActionIconButton = {
  ...actionIconButton,
  background: `${dangerColor} !important`,
};

const blankCardHeader = {
  padding: '0',
  margin: '0',
  background: '#fff',
  boxShadow: 'none',
  color: '#333',
  '& h1, h2, h3, h4, h5, h6': {
    fontWeight: '900',
    margin: '20px 15px',
    fontSize: '1.5rem'
  }
};

const customSelectStyles = {
  formControl: {
    margin: 0,
    flexGrow: 1,
    flexShrink: 1,
    minWidth: '250px',
    maxWidth: '250px',
    '& .MuiInputBase-root': {
      padding: 0,
      '& .MuiInputBase-input': {
        padding: '7px',
        border: 'solid 1px #ccc',
        borderRadius: '4px'
      },
      '& .MuiInputBase-input:hover': {
        border: 'solid 1px #aaa'
      },
      '& svg': {
        fill: '#ccc'
      }
    }
  }
};

export {
  //variables
  drawerWidth,
  drawerMiniWidth,
  transition,
  container,
  containerFluid,
  boxShadow,
  card,
  defaultFont,
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  secondblueColor,
  grayColor,
  covidBlueColor,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  secondblueBoxShadow,
  // old card header colors
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  secondblueCardHeader,
  whiteCardHeader,
  // new card header colors
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  tooltip,
  title,
  cardTitle,
  cardSubtitle,
  cardLink,
  actionButton,
  blankCardHeader,
  customSelectStyles,
  dangerActionButton,
  actionIconButton,
  dangerActionIconButton,
};



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react.jsx
